// Validation check fields for GroupToBusinessRoleGrid (Type 5)
export const validationCheckFields = [
    { key: 'validation_ActionType', labelKey: 'ActionType' },
    {
        key: 'validation_ApplicationIdentifier',
        labelKey: 'ApplicationIdentifier',
    },
    {
        key: 'validation_ApplicationRoleIdentifier',
        labelKey: 'ApplicationRoleIdentifier',
    },
    { key: 'validation_LocationIdentifier', labelKey: 'LocationIdentifier' },
    {
        key: 'validation_BusinessRoleIdentifier',
        labelKey: 'BusinessRoleIdentifier',
    },
]

